<template>
    <div class="supervisor-paramaters">
        <div class="card p-3">
            <section id="basic-examples">
                        <div class="d-inline-block">
                            <h2>Paramètres agent - {{$route.params.skill}} -
                                <span v-if="$route.params.agent.first_name && $route.params.agent.last_name">{{$route.params.agent.first_name}} {{$route.params.agent.last_name}}</span>
                                <span v-else>{{$route.params.agent.email}}</span>
                            </h2>
                            <div class="d-flex align-items-center">
                                <div class="p-1">
                                    <img src="@/app-assets/images/user-guest.png" class="rounded-circle  height-150" alt="Card image" v-if="!$route.params.agent.avatar">
                                    <img v-bind:src="$route.params.agent.avatar" class="rounded-circle  height-150" alt="Card image" v-else>
                                </div>
                                <div class="card-body">
                                    <h3 class="info">
                                        <strong v-if="$route.params.agent.first_name && $route.params.agent.last_name">{{$route.params.agent.first_name}} {{$route.params.agent.last_name}}</strong>
                                        <strong v-else>{{$route.params.agent.email}}</strong>
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="card-body">
                                <p>
                                    <strong>Adresse e-mail</strong> {{$route.params.agent.email}}
                                </p>
                                <p>
                                    <strong>Compétences</strong> <span v-for="(skill, index) in $route.params.agent.skills" :key="index + 'agent-skill'"> {{skill.label}} </span>
                                </p>
                                <p>
                                    <strong>Catégorie</strong> {{$route.params.agent.kind}}
                                </p>
                                <p>
                                    <strong>Dernière connexion</strong> {{$route.params.agent.last_login | formatLongDatetime}}
                                </p>
                                <p>
                                    <strong>Nombre de discussions simultanées maximales</strong> {{$route.params.agent.max_rooms}}
                                </p>
                            </div>
                        </div>
            </section>
        </div>
    </div>
</template>
<script>
export default {
  beforeMount: function () {
    this.$store.dispatch('resetAgentsList')
  }
}
</script>

<style lang="scss">
</style>
